import React from "react";
import { PageBanner, SectionTitle } from "../components/Shared";
import Icon from "../components/Icon";
import { ACTIVITIES } from "../data/siteData";
import "./InnerPages.css";

const LifeAtIdpsPage = () => {
  return (
    <>
      <PageBanner title="Life @ IDPS" breadcrumb="Life @ IDPS" />
      <section className="section">
        <div className="container">
          <SectionTitle
            title="Life at IDPS Mahore"
            subtitle="Beyond academics — a vibrant campus life that shapes well-rounded individuals."
          />
          <div className="grid-4">
            {ACTIVITIES.map((a) => (
              <div key={a.title} className="activity-card card">
                <div className="activity-card__icon"><Icon name={a.icon} size={26} /></div>
                <h3>{a.title}</h3>
                <p>{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default LifeAtIdpsPage;
